import { FC, useCallback, useMemo } from "react";
import "./MisceleniousStyles.css";

interface IColorPickerProps {
    onColorSelected: (color: string) => void;
    options: string[];
    defaultColor?: string;
}

const ColorPicker: FC<IColorPickerProps> = ({ 
    options, 
    onColorSelected, 
    defaultColor 
}) => {
    const selectedColor = defaultColor;

    const handleColorPick = useCallback((color: string) => {
        onColorSelected(color);
    }, [onColorSelected]);

    const colorOptions = useMemo(() => {
        if (options.length === 0) return null;
        
        return options.map((color) => (
            <div
                key={color}
                style={{ backgroundColor: color }}
                className={`color-picker-color-variant ${selectedColor === color ? "selected" : ""}`}
                onClick={() => handleColorPick(color)}
                role="button"
                tabIndex={0}
                aria-label={`Select color ${color}`}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleColorPick(color);
                    }
                }}
            />
        ));
    }, [options, selectedColor, handleColorPick]);

    if (!colorOptions) {
        return null;
    }

    return (
        <div 
            className="color-picker-pallet-zone"
            role="group"
            aria-label="Color picker"
        >
            {colorOptions}
        </div>
    );
};

export default ColorPicker;